import React from 'react';
import classNames from 'classnames';
// import { Link } from 'react-router-dom'; // Removed unused import

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      
    </nav>
  );
}

export default FooterNav;